import api from './api';

export interface HallOfFameEntry {
  mitarbeiter_id: number;
  vorname: string;
  nachname: string;
  gesamt_punkte: number;
  anzahl_kritisch: number;
  anzahl_hoch: number;
  anzahl_mittel: number;
  anzahl_niedrig: number;
  anzahl_info: number;
  anzahl_gesamt: number;
  rang: number;
  avatar_file_id?: number | null;
}

export interface HallOfFameMonthResponse {
  jahr: number;
  monat: number;
  eintraege: HallOfFameEntry[];
}

export interface HallOfFameAllTimeResponse {
  eintraege: HallOfFameEntry[];
}

export interface HallOfFameTrendEntry {
  jahr: number;
  monat: number;
  mitarbeiter_id: number;
  vorname: string;
  nachname: string;
  gesamt_punkte: number;
}

export interface HallOfFameTrendResponse {
  eintraege: HallOfFameTrendEntry[];
}

export const hallOfFameService = {
  getMonth: async (jahr?: number, monat?: number): Promise<HallOfFameMonthResponse> => {
    const params: Record<string, number> = {};
    if (jahr !== undefined) params.jahr = jahr;
    if (monat !== undefined) params.monat = monat;
    const response = await api.get('/hall-of-fame/monat', { params });
    return response.data;
  },

  getAllTime: async (): Promise<HallOfFameAllTimeResponse> => {
    const response = await api.get('/hall-of-fame/all-time');
    return response.data;
  },

  getTrend: async (jahr?: number, monate?: number): Promise<HallOfFameTrendResponse> => {
    const params: Record<string, number> = {};
    if (jahr !== undefined) params.jahr = jahr;
    if (monate !== undefined) params.monate = monate;
    const response = await api.get('/hall-of-fame/trend', { params });
    return response.data;
  },
};
